import * as React from 'react';

import axios from 'axios';
import {isAnimationContent, isV2ResponseSuccess, LinkedContentsResponse} from 'src/app/pages/bookDetail/types';
import { BookBenefit } from './items/NoticeBenefitItem';
import { BookDetailContext } from '../BookDetailContext';
import { BookEvent } from './items/NoticeEventItem';
import { LinkedContent } from './items/NoticeLinkedContentsItem';
import { NoticeList } from './NoticeList';
import { NoticeSelect } from './NoticeSelect';
import { WaitFree } from '../WaitFree';

export interface Item {
  type: ItemType;
  title: string;
  content: string;
}

export enum ItemType {
  NOTICE_NORMAL = 'NOTICE_NORMAL',
  SERIAL_SCHEDULE = 'SERIAL_SCHEDULE',
  CURRENT_SERIAL_SCHEDULE = 'CURRENT_SERIAL_SCHEDULE',
  SERIAL_DELAYED = 'SERIAL_DELAYED',
  SERIAL_DELAYED_BY_AUTHOR = 'SERIAL_DELAYED_BY_AUTHOR',
  DEPRECATED_NOTICE_LAFTEL_CONTENTS = 'NOTICE_LAFTEL_CONTENTS'
}

export enum DisplayType {
  SCHEDULE = 'schedule',
  NOTICE = 'notices',
  EVENTS = 'events',
  BENEFIT = 'benefits',
  LINKED_CONTENTS = 'linkedContents'
}

export type NoticeItem = Item | BookEvent | BookBenefit | LinkedContent[];

interface Props {
  events: BookEvent[];
  benefits: BookBenefit[];
  haveRidiSelectBookInSetBooks: boolean;
  setBookElementId: string;
  isRidiSelectBook: boolean;
  ridiSelectDetailUrl: string;
}

type State = {
  [type in DisplayType]: Array<NoticeItem>;
}

export class Notice extends React.Component<Props, State> {
  static contextType = BookDetailContext;
  declare context: React.ContextType<typeof BookDetailContext>;

  constructor (props: Props) {
    super(props);

    this.state = {
      schedule: [],
      notices: [],
      events: props.events,
      benefits: props.benefits,
      linkedContents: []
    };

  }

  // TODO: use redux store
  componentDidMount() {
    const { bookApiUrl, apiServerUrl, bookId } = this.context;
    axios
      .get<{ notices: Item[] }>(`${bookApiUrl}/books/${bookId}/notices`)
      .then((response) => {
        const notices = response.data?.notices ?? [];
        const result = notices.reduce<State>((acc, item): State => {
          return Notice.parseNoticeType(acc, item)
        }, {} as State);
        this.setState(result);
      });

      axios
        .get<LinkedContentsResponse>(`${apiServerUrl}/v1/linked-contents/${bookId}`)
        .then(({ data }) => {
          if (!isV2ResponseSuccess(data)) {
            return;
          }

          if (!data.data.linked_contents) {
            return;
          }

          const linkedContents = [ ...data.data.linked_contents.books, ...data.data.linked_contents.animations ];
          const hasLinkedContentsExceptMe = linkedContents.some(content =>
            isAnimationContent(content) || content.book_id !== `${bookId}`
          );

          if (!hasLinkedContentsExceptMe) {
            return;
          }

          this.setState(state => ({
            ...state,
            linkedContents: [ linkedContents ]
          }))
        });
  }

  static parseNoticeType(result: State, item: Item) {
    switch(item.type) {
      case ItemType.CURRENT_SERIAL_SCHEDULE: {
        const type = DisplayType.SCHEDULE;
        Array.isArray(result[type]) ? result[type].push(item) : result[type] = [item];
        return result;
      }

      case ItemType.DEPRECATED_NOTICE_LAFTEL_CONTENTS: {
        // Integrated with LinkedContents, ignoring...
        return result;
      }

      default: {
        const type = DisplayType.NOTICE;
        Array.isArray(result[type]) ? result[type].push(item) : result[type] = [item];
        return result;
      }
    }
  }

  hasChild(): boolean {
    return Object.values(this.state).some((v) => v.length > 0);
  }

  render() {
    const { schedule, notices, events, benefits, linkedContents } = this.state;
    const {
      haveRidiSelectBookInSetBooks,
      setBookElementId,
      isRidiSelectBook,
      ridiSelectDetailUrl
    } = this.props;

    const { bookId } = this.context;

    return (
      <li className="BookDetailNotice">
        {
          this.hasChild() && <>
            <NoticeList
              header="연재"
              type="schedule"
              items={schedule}
            />
            <NoticeList
              header="공지"
              type="notices"
              items={notices}
            />
            <NoticeList
              header="혜택"
              type="benefits"
              items={benefits}
            />
            <NoticeList
              header="이벤트"
              type="events"
              items={events}
            />
          </>
        }        
       
        <WaitFree
          bookId={bookId}
        />
        <NoticeSelect
          haveRidiSelectBookInSetBooks={haveRidiSelectBookInSetBooks}
          setBookElementId={setBookElementId}
          isRidiSelectBook={isRidiSelectBook}
          ridiSelectDetailUrl={ridiSelectDetailUrl}
          />
        <NoticeList
          header="추천"
          type="linkedContents"
          items={linkedContents}
        />
      </li>
    );
  }
};



// WEBPACK FOOTER //
// ./pages/bookDetail/components/Notice/Notice.tsx